<template>
	<div style="padding-top: 10px;">
		<a-card title="数据概览" style="width: 100%" size="small">
			<div slot="extra">
				<a-radio-group default-value="a" size="small" v-model="type" @change="changeType">
					<a-radio-button value="day">今日</a-radio-button>
					<a-radio-button value="week">近7日</a-radio-button>
					<a-radio-button value="month">近30日</a-radio-button>
				</a-radio-group>
			</div>
			<a-row :gutter="16">
				<a-col :span="3">
					<a-statistic title="成交金额" :value="indexCount.totalAmount">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="核销金额" :value="indexCount.dealAmount">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="退款金额" :value="indexCount.refundAmount">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="订单总数" :value="indexCount.orderCount">
						<template #suffix><span style="color: #7e868f;">笔</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="订票总数" :value="indexCount.ticketCount">
						<template #suffix><span style="color: #7e868f;">张</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="入园人数" :value="indexCount.enterCount">
						<template #suffix><span style="color: #7e868f;">人</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="待检票数" :value="indexCount.waitCheckCount">
						<template #suffix><span style="color: #7e868f;">张</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="退订张数" :value="indexCount.cancelCount">
						<template #suffix><span style="color: #7e868f;">张</span></template>
					</a-statistic>
				</a-col>
			</a-row>
		</a-card>
		
		<div style="display: flex;margin-top: 10px;">
			<a-card title="票种销售分析" style="width:  calc(40% - 5px);margin-right: 10px;" size="small">
				<div id="pzfx" style="height: calc(100vh - 394px);width: 100%;"></div>
			</a-card>
			
			<a-card title="营业额趋势图" style="width:  calc(60% - 5px);" size="small">
				<div id="yyeqst" style="height: calc(100vh - 394px);width: 100%;"></div>
			</a-card>
		</div>
		<a-card title="系统公告" style="margin-top: 10px;height: 100px;" size="small">
			<div>暂无</div>
		</a-card>

		
		

	</div>

</template>
<script>
	import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
	export default {
		data() {
			return {
				staff: {
					staffAccount: window.sessionStorage.getItem('staffAccount'),
					staffId: window.sessionStorage.getItem('staffId')
				},
				type: 'day',
				date: '',
				indexCount: {
					totalAmount: 0,
					dealAmount: 0,
					refundAmount: 0,
					orderCount: 0,
					ticketCount: 0,
					enterCount: 0,
					waitCheckCount: 0,
					cancelCount: 0,
				},
				productList: [],
				dateList: [],
				productData: [],

			};
		},
		methods: {
			async getProductList(){
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductList,{})
				if (res.code == 200) {
					this.productList = res.data
				} else {
					this.$message.error(res.msg)
				}
			
			},
			async getIndexCount(){
				const {
					data: res
				} = await this.$http.post(this.navigation.apiIndexCount, {
					staffId: this.staff.staffId,
					type: this.type,
					date: this.date
				})
				if (res.code == 200) {
					this.indexCount = res.data
					this.parseIndexCount()
				} else {
					this.$message.error(res.msg)
				}
			},
			parseIndexCount(){
				// 成交金额
				let totalAmount =  0;
				// 核销金额
				let dealAmount = 0;
				// 退款金额
				let refundAmount = 0;
				// 订单总数
				let orderCount = 0;
				// 订票总数
				let ticketCount = 0;
				// 入园人数
				let enterCount = 0;
				// 待检票数
				let waitCheckCount = 0;
				// 退订张数
				let cancelCount = 0;
				let orderList = [];
				let dateList = [];
				this.productData = []
				for(let key in this.indexCount){
					totalAmount = totalAmount + Number(this.indexCount[key].totalPrice/100)
					// dealAmount = dealAmount + Number(this.indexCount[key].dealPrice/100)
					ticketCount = ticketCount + Number(this.indexCount[key].quantity)
					enterCount = enterCount + Number(this.indexCount[key].checkedQuantity)
					cancelCount = cancelCount + Number(this.indexCount[key].refundQuantity)
					refundAmount = refundAmount + Number(this.indexCount[key].totalPrice / this.indexCount[key].quantity * this.indexCount[key].refundQuantity/100)
					if(!orderList.includes(this.indexCount[key].ordersNumber)){
						orderList.push(this.indexCount[key].ordersNumber)
					}
					let product = this.productList.find(item=>item.productId == this.indexCount[key].productId)
					if(product){
						let productData = this.productData.find(item=>item.id == this.indexCount[key].productId)
						if(productData){
							productData.value = productData.value + Number(this.indexCount[key].quantity)
							let dateValue = productData.dateValue.find(item=>item.date == this.indexCount[key].createTime.split(' ')[0])
							if(dateValue){
								dateValue.value = dateValue.value + Number(this.indexCount[key].quantity)
							}else{
								productData.dateValue.push({
										date: this.indexCount[key].createTime.split(' ')[0],
										value: Number(this.indexCount[key].quantity),
								})
							}
						}else{
							productData = {
								id: product.productId,
								name: product.productName,
								value: Number(this.indexCount[key].quantity),
								dateValue:[{
										date: this.indexCount[key].createTime.split(' ')[0],
										value: Number(this.indexCount[key].quantity),
								}]
							}
							this.productData.push(productData)
						
						}
					}
				
					const date = dateList.find(item=>item == this.indexCount[key].createTime.split(' ')[0])
					if(!date){
						dateList.push(this.indexCount[key].createTime.split(' ')[0])
					}
				}
				dealAmount = totalAmount - refundAmount
				orderCount = orderList.length
				waitCheckCount = ticketCount - enterCount - cancelCount
				this.indexCount.totalAmount = totalAmount.toFixed(2)
				this.indexCount.dealAmount = dealAmount.toFixed(2)
				this.indexCount.refundAmount = refundAmount.toFixed(2)
				this.indexCount.orderCount = orderCount
				this.indexCount.ticketCount = ticketCount
				this.indexCount.enterCount = enterCount
				this.indexCount.waitCheckCount = waitCheckCount
				this.indexCount.cancelCount = cancelCount
				this.dateList = dateList
				this.pzfx()
				this.yyeqst()
				
			},
			changeType(e){
				this.type = e.target.value
				this.getIndexCount()
			},
			pzfx() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById("pzfx"));
				// 指定图表的配置项和数据
				let option = {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center'
					},
					series: [{
						name: '票种销售分析',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
				  labelLine: {
							show: false
						},
						data: this.productData
					}]
				};
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
			createColor(n){
				let colorList = ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'];
				let result = [];
				for(let i = 0; i < n; i++){
					result.push(colorList[i % colorList.length]);
				}
				return result;
			},
			yyeqst() {
				const productData = this.productData
				let colorList = this.createColor(productData.length);
				let datePrarm = [];
				let productNameList = [];
				for(let key in productData){
					const productName = this.productData[key].name
					let productNumber = []
					productNameList.push(productName)
					for(let key2 in this.dateList){
						if(productData[key].dateValue.find(item=>item.date == this.dateList[key2])){
							productNumber.push(productData[key].dateValue.find(item=>item.date == this.dateList[key2]).value)
						}else{
							productNumber.push(0)
						}
					}
					const param = {
						name: productName,
						type: 'line',
						stack: 'Total',
						smooth: true,
						lineStyle: {
							width: 0
						},
						showSymbol: false,
						areaStyle: {
							opacity: 0.8,
							color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0,
									color: colorList[parseInt(key)]
								},
								// {
								// 	offset: 1,
								// 	color: colorList[(parseInt(key) + 1) % colorList.length]
								// }
							])
						},
						emphasis: {
							focus: 'series'
						},
						data: productNumber
					}
					datePrarm.push(param)
				}

				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById("yyeqst"));
				let option = {
				  color: colorList,
				  title: {
				    text: ''
				  },
				  tooltip: {
				    trigger: 'axis',
				    axisPointer: {
				      type: 'cross',
				      label: {
				        backgroundColor: '#6a7985'
				      }
				    }
				  },
				  legend: {
				    data: productNameList
				  },
				  toolbox: {
				    feature: {
				      saveAsImage: {}
				    }
				  },
				  grid: {
				    left: '3%',
				    right: '4%',
				    bottom: '3%',
				    containLabel: true
				  },
				  xAxis: [
				    {
				      type: 'category',
				      boundaryGap: false,
				      data: this.dateList
				    }
				  ],
				  yAxis: [
				    {
				      type: 'value'
				    }
				  ],
				  series: datePrarm,

				//   [
				//     {
				//       name: '测试门票(全价票)',
				//       type: 'line',
				//       stack: 'Total',
				//       smooth: true,
				//       lineStyle: {
				//         width: 0
				//       },
				//       showSymbol: false,
				//       areaStyle: {
				//         opacity: 0.8,
				//         color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				//           {
				//             offset: 0,
				//             color: 'rgb(128, 255, 165)'
				//           },
				//           {
				//             offset: 1,
				//             color: 'rgb(1, 191, 236)'
				//           }
				//         ])
				//       },
				//       emphasis: {
				//         focus: 'series'
				//       },
				//       data: [140, 232, 101, 264, 90, 340, 250]
				//     },
				//     {
				//       name: '测试门票(半价票)',
				//       type: 'line',
				//       stack: 'Total',
				//       smooth: true,
				//       lineStyle: {
				//         width: 0
				//       },
				//       showSymbol: false,
				//       areaStyle: {
				//         opacity: 0.8,
				//         color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				//           {
				//             offset: 0,
				//             color: 'rgb(0, 221, 255)'
				//           },
				//           {
				//             offset: 1,
				//             color: 'rgb(77, 119, 255)'
				//           }
				//         ])
				//       },
				//       emphasis: {
				//         focus: 'series'
				//       },
				//       data: [120, 282, 111, 234, 220, 340, 310]
				//     },
				//     {
				//       name: '测试车票(全价票)',
				//       type: 'line',
				//       stack: 'Total',
				//       smooth: true,
				//       lineStyle: {
				//         width: 0
				//       },
				//       showSymbol: false,
				//       areaStyle: {
				//         opacity: 0.8,
				//         color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				//           {
				//             offset: 0,
				//             color: 'rgb(55, 162, 255)'
				//           },
				//           {
				//             offset: 1,
				//             color: 'rgb(116, 21, 219)'
				//           }
				//         ])
				//       },
				//       emphasis: {
				//         focus: 'series'
				//       },
				//       data: [320, 132, 201, 334, 190, 130, 220]
				//     },
				//     {
				//       name: '测试车票(半价票)',
				//       type: 'line',
				//       stack: 'Total',
				//       smooth: true,
				//       lineStyle: {
				//         width: 0
				//       },
				//       showSymbol: false,
				//       areaStyle: {
				//         opacity: 0.8,
				//         color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				//           {
				//             offset: 0,
				//             color: 'rgb(255, 0, 135)'
				//           },
				//           {
				//             offset: 1,
				//             color: 'rgb(135, 0, 157)'
				//           }
				//         ])
				//       },
				//       emphasis: {
				//         focus: 'series'
				//       },
				//       data: [220, 402, 231, 134, 190, 230, 120]
				//     },
				//   ]
				}
				myChart.setOption(option);
			}

		},
		mounted() {
			this.getProductList().then(() => {
				this.getIndexCount()
			})

		},
		created() {

		}
	};
</script>

<style lang="less">

</style>
